var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("mt-1 pt-1 " + (_vm.field.classes))},[_vm._v(_vm._s(_vm.field.title))])}
var staticRenderFns = []

export { render, staticRenderFns }